<template>
    <div>
        <v-card
            flat
            :ripple      = "false"
            @contextmenu = "showContext"
            class        = "pa-0 ma-0 h-100"
        >
            <drag
                @cut      = "onRemove(document)"
                :type     = "docData(document)"
                :data     = "docData(document)"
                :disabled = "!enableDrag"
                class     = "v-flex h-100"
            >
                <a @click="onDocument" class="w-100" >
                    <p-dms-detail-menu-entry-label :document = document />
                </a>
            </drag>
        </v-card>
        <v-menu
            v-if          = "enableMenu"
            v-model       = "showContectMenu"
            content-class = "menu-class"
            :position-x   = "x"
            :position-y   = "y"
            offset-y
        >
            <v-list style="cursor: pointer; border: none; box-shadow: none">
                <v-list-item @click="onShowDocument">
                    <div>
                        <i class="fas fa-eye"></i>
                        <span class="ml-3">anzeigen</span>
                    </div>
                </v-list-item>
                <v-list-item @click="onFadeInDocument">
                    <div class="v-flex">
                        <v-icon class="ml-n1" size="22" color="black">mdi-open-in-new</v-icon>
                        <div class="ml-3">einblenden</div>
                    </div>
                </v-list-item>
                <v-list-item
                    @click="onConfirmDetach"
                    v-if="(!document.stamped && document.messageId) && document.typename !== 'Mail - gesendet' && !document.referenced">
                    <div>
                        <i class="fas fa-unlink"></i>
                        <span class="ml-3">vom Ereignis lösen</span>
                    </div>
                </v-list-item>
                <v-list-item @click="onConfirmDelete" v-if="(!document.messageId || document.stamped) && !document.referenced">
                    <div>
                        <i class="fas fa-trash-alt"></i>
                        <span class="ml-3">löschen</span>
                    </div>
                </v-list-item>
                <v-list-item @click="onDownload">
                    <div>
                        <i class="fas fa-download"></i>
                        <span class="ml-3">Download</span>
                    </div>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import Inb    from "@/modules/inb/service/Inb";
import Dms    from "@/modules/dms/common/service/Dms";
import {Drag} from "vue-easy-dnd"
import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";
import PDmsDetailMenuEntryLabel from "@/modules/dms/menu/components/private/PDmsDetailMenuEntryLabel.vue";

export default {
    name: "PDmsDetailMenuEntry",

    components: {
        PDmsDetailMenuEntryLabel,
       Drag,
    },

    props: {
        document: {

        },

        enableMenu: {
            default: function () {
                return true;
            }
        },

        enableDrag: {
            default: function () {
                return true;
            }
        }
    },

    data: () => ({
        showContectMenu: false,
        x: null,
        y: null
    }),

    computed: {

    },

    methods: {
        /**
         * Called when the user selects a document directly by clicking on it. The context menu may have to be closed.
         */
        onDocument () {
            if (this.showContectMenu) {
                this.showContectMenu = false;
                return;
            }

            this.$emit("selected", this.document)
        },

        /**
         * Called when the user selects a document by the document's context menu.
         */
        onShowDocument () {
            Dms.open(this.document.id, this.document.name);
        },

        onFadeInDocument () {
            this.$bus.$emit(this.$events.dms.fadein, this.document);
        },

        onDownload () {
            Dms.download(this.document.id, (filename, data)  => {
                let link = document.createElement('a');
                link.href = data;
                link.download = filename ? filename : this.document.name;
                link.click()
            });
        },

        /**
         *
         */
        onConfirmDetach () {
            Core.message.confirm(
                this,
                this.$t("inc.confirm.document.detach.query"),
                this.$t("inc.confirm.document.detach.text"),
                Core.message.Default,
                () => {
                Inb.detach(this, this.document.messageId).then (() => {
                    this.load();
                    this.$bus.$emit(Inb.event.refresh);
                    this.confirm = false;
                });
            });
        },

        /**
         *
         */
        onConfirmDelete () {
            Core.message.confirm(
                this,
                this.$t("inc.confirm.document.delete.query"),
                this.$t("inc.confirm.document.delete.text"),
                Core.message.Default,
                () => {
                    Inc.document.remove (this, this.document.id).then(()=> {})
                });
        },

        onSelected (value) {
            this.$emit("selected", {
                id      : this.document.id,
                selected: value
            });
        },

        /**
         *
         * @param e
         */
        showContext (e) {
            e.preventDefault()
            if (this.selectable) {
                return;
            }

            this.showContectMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.$emit("changed", this.document.id)
                this.showContectMenu = true
            })
        },

        onRemove () {

        },

        docData (item) {
            return {
                type: "dms-document",
                data: item
            };
        },
    }
}
</script>

<style scoped>

.doc-select {
    position: absolute;
    margin-left: 40px;
    margin-top: 0;
}

.menu-class {
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 10%), 0 8px 10px 1px rgb(0 0 0 / 10%), 0 3px 14px 2px rgb(0 0 0 / 10%);
}

</style>